import React from 'react';
import classNames from 'classnames';

import {formatDate} from 'utils/datetime';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';
import CreditNoteStatusTag from 'components/CreditNoteStatusTag';

import {getSyncedWithXeroIcon} from 'containers/BookingDetail/utils';

const CreditNoteRow = ({creditNote, handleRowClick, scheduleType}) => {
  const {creditNoteDetails} = creditNote;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: creditNote.highlighted
      })}
      onClick={() =>
        handleRowClick(
          SCHEDULE_ITEM_TYPES.CREDIT_NOTE,
          creditNote.id,
          scheduleType
        )
      }>
      <Table.Cell>{formatDate(creditNote.date)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="activity">
        <div className="colab-centered">
          {creditNoteDetails.hasXeroErrors && <Alert />}
          <Ellipsis>{creditNote.activity}</Ellipsis>
        </div>
      </Table.Cell>
      <Table.Cell className="details">
        <Ellipsis>{creditNoteDetails.description}</Ellipsis>
      </Table.Cell>
      <Table.Cell>
        <CreditNoteStatusTag
          status={creditNoteDetails.status}
          label={creditNoteDetails.status}
        />
      </Table.Cell>
      <Table.Cell>{getSyncedWithXeroIcon(creditNoteDetails.xeroId)}</Table.Cell>
      <Table.Cell className="amount">
        <Money
          amount={-creditNote.amount}
          balance
          className={classNames({
            strikeThrough: creditNoteDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell />
      <Table.Cell className="balance">
        <Money amount={creditNote.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default CreditNoteRow;
